

export class AccountClass {
    id: string;
    name: string;
    nameE: string;
}